export const calculateSpeedFromRadius = (radius) => {
    radius = Math.abs(radius);
    if(radius > 0 && radius < 100)
    {
        return 68.0495193634352 / (1+1.6550049899824 * Math.exp(-0.0246787723513*radius));
    }
    else if(radius >= 100 && radius < 125)
    {
        return (0.2336165534765 * radius) + 36.3028466614975;
    }
    else if(radius >= 125 && radius < 150)
    {
        return (0.1964301145925 * radius) + 40.9511515220018;
    }
    else if(radius >= 150 && radius < 175)
    {
        return (0.1063249651586 * radius) + 54.4669239370937;
    }
    else if(radius >= 175 && radius < 200)
    {
        return (0.068784745388 * radius) + 61.0364623969411;
    }
    else if(radius >= 200 && radius < 225)
    {
        return (0.0338060047759 * radius) + 68.0322105193624;
    }
    else if(radius >= 225 && radius < 250)
    {
        return (0.1636593172529 * radius) + 38.8152152120398;
    }
    else if(radius >= 250)
    {
        return 80;
    }
}